const CommonSidebar = () => import(/* webpackChunkName: "component.header" */ '@/components/Sidebar');
const CommonHeader = () => import(/* webpackChunkName: "component.header" */ '@/components/Header');
const CommonFooter = () => import(/* webpackChunkName: "component.header" */ '@/components/Footer');

export default {
  path: 'courses',
  components: {
    sidebar: CommonSidebar,
    header: CommonHeader,
    footer: CommonFooter,
    default: () => import(/* webpackChunkName: "module.courses" */ '@/views/Courses'),
  },
  meta: {
    breadcrumb: {
      label: 'Courses',
    },
  },
  children: [
    {
      path: '',
      name: 'courses-listing',
      component: () => import(/* webpackChunkName: "module.courses.list" */ '@/modules/Courses/List'),
      meta: {
        breadcrumb: {
          label: 'Courses',
        },
      },
    },
    {
      path: ':id/edit',
      name: 'courses-edit',
      component: () => import(/* webpackChunkName: "module.courses.edition" */ '@/modules/Courses/Edition'),
      meta: {
        breadcrumb: {
          parent: 'courses-listing',
          label: 'Edit Course',
        },
      },
    },
    {
      path: 'create',
      name: 'courses-create',
      component: () => import(/* webpackChunkName: "module.courses.edition" */ '@/modules/Courses/Edition'),
      meta: {
        breadcrumb: {
          parent: 'courses-listing',
          label: 'Create Course',
        },
      },
    },
  ],
};
